module.exports = __webpack_public_path__ + "assets/7a26bfff21d9ff1054b5272e8d0a670c.mp3";